//This is how everything on the frontend will interact with the API and hence the database.

// const API_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:3001/';
class INGREDIENTS {
    private data: ing;

    constructor(data: ing) {
        this.data = data;
    }

    getColors(numColors: number, uniqueGroups: boolean): string[] {
        let colors = this.data["colours"];
        let colorsToReturn: string[] = []
        let subgroupsUsed: string[] = []
        let subgroups = Object.keys(colors);
        let i=0
        while (i<numColors) {
            let index = Math.floor(Math.random()*subgroups.length)
            let subgroup = subgroups[index]
            if (uniqueGroups && subgroupsUsed.includes(subgroup)) {
                continue
            }
            i++
            let subgroupIndex = Math.floor(Math.random() * colors[subgroup].length);
            let color = colors[subgroup][subgroupIndex];
            colorsToReturn.push(color)
            subgroupsUsed.push(subgroup)
        }
        return colorsToReturn;
    }

    getNumGroups(): number {
        return Object.keys(this.data).length;
    }

    pickRandom(numEntries: number, includeColors: boolean, subgroupRepetition: boolean): string[] {
        const result: string[] = [];
        const usedSubgroups = new Set<string>();

        // Step 1: Prepare list of allowed group names
        const groupNames = Object.keys(this.data).filter(
            group => includeColors || group !== 'colours'
        );

        if (groupNames.length === 0) return result;

        // Step 2: Randomly pick items
        while (result.length < numEntries) {
            // Random group
            const group = groupNames[Math.floor(Math.random() * groupNames.length)];
            const subgroups = this.data[group];
            const subgroupNames = Object.keys(subgroups);

            if (subgroupNames.length === 0) continue;

            // Random subgroup
            const subgroup = subgroupNames[Math.floor(Math.random() * subgroupNames.length)];
            const subgroupKey = `${group}:${subgroup}`;

            if (!subgroupRepetition && usedSubgroups.has(subgroupKey)) {
            continue; // skip used subgroup
            }

            const values = subgroups[subgroup];
            if (!values || values.length === 0) continue;

            // Random value from subgroup
            const value = values[Math.floor(Math.random() * values.length)];

            result.push(value);
            if (!subgroupRepetition) {
            usedSubgroups.add(subgroupKey);
            }
        }
        return result;
    }

    pickRandomGroups(numToPick: number, maxColors: number, avoidRepeatProbability: number): string[] {
        let out: string[] = [];
        if ((avoidRepeatProbability >= 1) && (numToPick > (this.getNumGroups() - (maxColors?1:0)))) {
            throw new Error(`Not enough groups to pick ${numToPick} without repetition`);
        }
        let groups = Object.keys(this.data);
        while (out.length < numToPick) {
            let index = Math.floor(Math.random() * groups.length);
            let group = groups[index];
            if (group === "colour" && out.filter(x => x==="colour").length >= maxColors) {
                continue;
            }
            if (out.includes(group) && Math.random() < avoidRepeatProbability) {
                continue;
            }
            out.push(group);
        }
        return out;
    }

    sampleGroups(groups: string[], toAvoid: string[]) {
        let out: string[] = [];
        for (let group of groups) {
            let groupData = this.data[group];
            let subgroups = Object.keys(groupData);
            while (true) {
                let index = Math.floor(Math.random() * subgroups.length);
                let subgroup = subgroups[index];
                if (toAvoid.includes(subgroup)) {
                    continue;
                }
                toAvoid.push(subgroup);
                let subgroupData = groupData[subgroup]
                let item = subgroupData[Math.floor(Math.random() * subgroupData.length)];
                out.push(item);
                break;
            }
        }
        return out;
    }
};
type ing = {[group:string]: {[subgroup:string]: string[]}};



async function getIngredients(): Promise<INGREDIENTS> {
    const response = await fetch("/data/items.json", {method: 'GET'});
    const data: {[group: string]: (string[] | string)[]} = await response.json();
    return new INGREDIENTS(transformGroups(data));
}

function transformGroup(data: (string[] | string)[]): { [subgroup: string]: string[] } {
  return Object.assign({}, ...data.map(item => {
    if (typeof item === 'string') {
      return { [item]: [item] };
    } else {
      return { [item[0]]: item };
    }
  }));
}

function transformGroups(
  data: { [group: string]: (string[] | string)[] }
): { [group: string]: { [subgroup: string]: string[] } } {
  return Object.fromEntries(
    Object.entries(data).map(([group, items]) => [group, transformGroup(items)])
  );
}

export default getIngredients;
export type {INGREDIENTS};